var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overview-data-tag"},_vm._l((_vm.config),function(cell,i){return _c('div',{key:i,staticClass:"cell"},[_c('div',{staticClass:"tag"},[_vm._v(_vm._s(_vm.value[cell]))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }